import React from 'react';
import Styles from './styles.module.scss';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const Footer: React.FC = () => {
  // アニメーション背景用
  const { ref: bg0Ref, isVisible: isBg0Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg1Ref, isVisible: isBg1Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg2Ref, isVisible: isBg2Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg3Ref, isVisible: isBg3Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <footer className={Styles.footer}>
      <div className={Styles.footer__inner}>
        <div className={Styles.footer__inner__logo}>
          <picture>
            <source media="(min-width: 768px)" srcSet="/images/2025/logo_big.png" />
            <img src="/images/2025/logo_mid.png" alt="かまた祭" width={200} height={60} />
          </picture>
        </div>

        <div className={Styles.footer__inner__info}>
          <div className={Styles.footer__inner__info__date}>
            <p className={Styles.footer__inner__info__date__main}>2025.11</p>
          </div>

          <div className={Styles.footer__inner__info__time}>
            <div className={Styles.footer__inner__info__time__item}>
              <span className={Styles.footer__inner__info__time__item__day}>2</span>
              <span className={Styles.footer__inner__info__time__item__weekday}>(sun)</span>
              <span className={Styles.footer__inner__info__time__item__hours}>11:00〜17:00</span>
            </div>
            <div className={Styles.footer__inner__info__time__item}>
              <span className={Styles.footer__inner__info__time__item__day}>3</span>
              <span className={Styles.footer__inner__info__time__item__weekday}>(mon)</span>
              <span className={Styles.footer__inner__info__time__item__hours}>10:00〜16:00</span>
            </div>
          </div>
        </div>

        <div className={Styles.footer__inner__schools}>
          <p>
            <a href="https://www.neec.ac.jp/" rel="noreferrer noopener" target="_blank">
              日本工学院専門学校
            </a>
          </p>
          <p>
            <a href="https://www.teu.ac.jp/" rel="noreferrer noopener" target="_blank">
              東京工科大学
            </a>
          </p>
          <p>
            <a href="https://www.jst.ac.jp/" rel="noreferrer noopener" target="_blank">
              東京工科大学附属日本語学校
            </a>
          </p>
        </div>

        <div className={Styles.footer__inner__sponsor}>
          <p className={Styles.footer__inner__sponsor__label}>特別協力：</p>
          <div className={Styles.footer__inner__sponsor__logos}>
            <a href="https://corp.becalm.jp" rel="noreferrer noopener" target="_blank">
              <img src="/images/2025/becalm.svg" alt="Becalm" width={120} height={30} />
            </a>
          </div>
        </div>
      </div>

      <div className={Styles.footer__bg}>
        <div
          ref={bg0Ref}
          className={`${Styles.footer__bg__0} ${isBg0Visible ? Styles['footer__bg__0--visible'] : ''}`}
        >
          <svg
            width="1056"
            height="720"
            viewBox="0 0 1056 720"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              y="634.614"
              width="853.012"
              height="107.284"
              rx="53.6419"
              transform="rotate(-37.6131 0 634.614)"
              fill="url(#paint0_linear_5237_1239)"
            />
            <rect
              x="1055.01"
              y="31.3936"
              width="605.69"
              height="39.8208"
              rx="19.9104"
              transform="rotate(142.035 1055.01 31.3936)"
              fill="url(#paint1_linear_5237_1239)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_5237_1239"
                x1="0"
                y1="688.256"
                x2="853.012"
                y2="688.256"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#2F34BE" />
                <stop offset="0.947115" stopColor="#EEEEEE" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_5237_1239"
                x1="1660.7"
                y1="51.3039"
                x2="1055.01"
                y2="51.3039"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#EEEEEE" />
                <stop offset="0.538462" stopColor="#F6B8DF" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div
          ref={bg1Ref}
          className={`${Styles.footer__bg__1} ${isBg1Visible ? Styles['footer__bg__1--visible'] : ''}`}
        >
          <svg
            width="637"
            height="432"
            viewBox="0 0 637 432"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="345"
              y="300.028"
              width="282.981"
              height="91.1066"
              rx="45.5533"
              transform="rotate(-29.4259 345 300.028)"
              fill="url(#paint0_linear_5237_1240)"
            />
            <rect
              y="330.371"
              width="665.98"
              height="116.57"
              rx="58.2848"
              transform="rotate(-29.7401 0 330.371)"
              fill="url(#paint1_linear_5237_1240)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_5237_1240"
                x1="345"
                y1="345.582"
                x2="627.981"
                y2="345.582"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#D199ED" />
                <stop offset="1" stopColor="#CEDBFF" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_5237_1240"
                x1="0"
                y1="388.655"
                x2="665.98"
                y2="388.655"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#4A81FE" />
                <stop offset="1" stopColor="white" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div
          ref={bg2Ref}
          className={`${Styles.footer__bg__2} ${isBg2Visible ? Styles['footer__bg__2--visible'] : ''}`}
        >
          <svg
            width="380"
            height="457"
            viewBox="0 0 380 457"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M94.2372 278.476C95.5225 277.293 97.5704 278.446 97.2258 280.158L95.2915 289.769C95.1374 290.535 95.4939 291.313 96.1746 291.696L104.717 296.505C106.239 297.362 105.775 299.666 104.04 299.868L94.3024 300.998C93.5265 301.088 92.8968 301.667 92.7426 302.433L90.8084 312.044C90.4637 313.756 88.1292 314.027 87.4015 312.439L83.3174 303.527C82.9919 302.817 82.2462 302.397 81.4703 302.487L71.7323 303.617C69.9972 303.819 69.0181 301.682 70.3035 300.499L77.5173 293.861C78.0921 293.332 78.261 292.493 77.9355 291.783L73.8514 282.871C73.1237 281.283 74.8531 279.692 76.3752 280.549L84.9177 285.358C85.5984 285.741 86.4485 285.643 87.0233 285.114L94.2372 278.476Z"
              fill="#F6B8DF"
            />
            <path
              d="M49.5462 197.004C49.6227 196.866 49.8302 196.907 49.8491 197.063L52.7582 221.094C52.8162 221.573 53.1764 221.96 53.6499 222.053L77.4032 226.712C77.5575 226.743 77.5831 226.953 77.4406 227.019L55.484 237.212C55.0465 237.415 54.7896 237.877 54.8476 238.356L57.7567 262.387C57.7756 262.543 57.5835 262.632 57.4764 262.517L40.9976 244.785C40.6692 244.432 40.1508 244.33 39.7134 244.533L17.7568 254.726C17.6142 254.792 17.47 254.637 17.5465 254.499L29.3185 233.348C29.5531 232.927 29.4897 232.402 29.1614 232.049L12.6825 214.316C12.5757 214.201 12.6788 214.016 12.833 214.046L36.5873 218.706C37.0607 218.799 37.5397 218.576 37.7743 218.155L49.5462 197.004Z"
              fill="white"
              stroke="#1549B6"
              strokeWidth="0.951418"
            />
            <path
              d="M200.349 11.5228C200.63 9.7987 202.953 9.44084 203.739 11.0005L213.638 30.6329C213.99 31.3304 214.751 31.7221 215.523 31.6032L237.253 28.2553C238.98 27.9894 240.038 30.0879 238.797 31.3178L223.185 46.7991C222.63 47.3491 222.493 48.1938 222.844 48.8913L232.744 68.5236C233.53 70.0833 231.861 71.7381 230.308 70.9386L210.76 60.8742C210.065 60.5166 209.22 60.6469 208.665 61.1969L193.053 76.6782C191.812 77.9081 189.723 76.8323 190.003 75.1083L193.534 53.4069C193.66 52.6358 193.274 51.8717 192.58 51.5141L173.032 41.4498C171.479 40.6502 171.856 38.3305 173.583 38.0645L195.313 34.7167C196.085 34.5978 196.693 33.9952 196.818 33.2242L200.349 11.5228Z"
              fill="#F6B8DF"
            />
            <rect
              x="58.5366"
              y="441.59"
              width="222.564"
              height="18.2606"
              rx="9.1303"
              transform="rotate(-35.8157 58.5366 441.59)"
              fill="#A4A4A4"
            />
            <circle
              cx="223.519"
              cy="222.412"
              r="7.51302"
              transform="rotate(173.389 223.519 222.412)"
              fill="url(#paint0_linear_5237_1249)"
            />
            <rect
              x="369.76"
              y="124.75"
              width="152.577"
              height="18.2606"
              rx="9.1303"
              transform="rotate(143.649 369.76 124.75)"
              fill="url(#paint1_linear_5237_1249)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_5237_1249"
                x1="216.006"
                y1="229.295"
                x2="233.628"
                y2="221.135"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#A6A8EF" />
                <stop offset="1" stopColor="#0B48F1" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_5237_1249"
                x1="369.76"
                y1="142.245"
                x2="383.368"
                y2="89.5972"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#A6A8EF" />
                <stop offset="1" stopColor="#0B48F1" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div
          ref={bg3Ref}
          className={`${Styles.footer__bg__3} ${isBg3Visible ? Styles['footer__bg__3--visible'] : ''}`}
        >
          <svg
            width="205"
            height="205"
            viewBox="0 0 205 205"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="102.943"
              cy="102.943"
              r="99.8964"
              stroke="white"
              strokeWidth="4.20729"
              strokeDasharray="6.01 6.01"
            />
          </svg>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
